/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SwatchSelector_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedSwatchSelector_user$ref: FragmentReference;
export type PdpSharedSwatchSelector_user = {|
  +$fragmentRefs: SwatchSelector_user$ref,
  +$refType: PdpSharedSwatchSelector_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedSwatchSelector_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SwatchSelector_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '96240956714100b9e6e90964e8837a44';
module.exports = node;
